
    <h2 mat-dialog-title style="font-size:1.4em;">Add this job to a trip?</h2>
    <div mat-dialog-content>
      <mat-radio-group [(ngModel)]="action" style="display:flex;flex-direction:column;gap:12px;">
        <mat-radio-button value="newTrip">Turn this job into a new trip</mat-radio-button>
        <mat-radio-button value="addToTrip" [disabled]="!data.openTrips?.length">
          Add this job to an existing trip
          <span *ngIf="!data.openTrips?.length" style="opacity:0.7;">(no open trips at this location)</span>
        </mat-radio-button>
        <mat-radio-button value="none">Do neither</mat-radio-button>
      </mat-radio-group>

      <p *ngIf="action === 'newTrip' && !data.jobIsOpen" style="margin-top:16px;opacity:0.8;">
        This job is {{ data.jobStatus || 'not Scheduled' }}, so the new trip will be created as Complete. The job keeps its own status.
      </p>

      <div *ngIf="action === 'addToTrip'" style="margin-top:16px;">
        <p *ngIf="data.jobIsOpen" style="opacity:0.8;">The job will take the selected trip's date and status.</p>
        <p *ngIf="!data.jobIsOpen" style="opacity:0.8;">
          This job is {{ data.jobStatus || 'not Scheduled' }}, so it keeps its own date and status.
        </p>
        <mat-radio-group [(ngModel)]="selectedTripId" style="display:flex;flex-direction:column;gap:10px;margin-left:24px;">
          <mat-radio-button *ngFor="let trip of data.openTrips" [value]="trip.job_id">
            <span style="font-weight:500;">{{ trip.schedule_date | date:'MMM d, y' }}</span>
            <span style="margin:0 8px;">—</span>
            <span>{{ trip.customer_jobtype }}</span>
            <span style="margin-left:8px;font-size:0.85em;opacity:0.7;">({{ trip.job_status }})</span>
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <div mat-dialog-actions align="end" style="gap:8px;">
      <button mat-flat-button color="primary" [disabled]="action === 'addToTrip' && !selectedTripId" (click)="confirm()">OK</button>
    </div>
  